import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index.js';
import i18n from '../plugins/vue-i18n.js';
import errors from '../plugins/errors.js';
import initProgress from '../plugins/nprogress.js';

import appointments from './appointments.js';
import auth from './auth.js';
import automations from './automations.js';
import campaigns from './campaigns.js';
import chat from './chat.js';
import configs from './configs.js';
import contacts from './contacts.js';
import imports from './imports.js';
import payments from './payments.js';
import redirects from './redirects.js';

Vue.use(Router);

const router = new Router({
    linkExactActiveClass: '',
    mode: 'history',
    routes: [
        ...redirects,
        ...appointments,
        ...auth,
        ...automations,
        ...campaigns,
        ...chat,
        ...configs,
        ...contacts,
        ...imports,
        ...payments,

        // Not Found
        {
            path: '*',
            component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue'),
            meta: {
                title: '',
            },
        },
    ],
});

// Remove hash from route
router.beforeEach((to, from, next) => {
    if (to.hash) {
        next({ ...to, hash: '' });
    }

    next();
});

// This callback runs before every route change, including on page load.
router.afterEach(to => {
    errors.flush();

    if (to.meta.title !== 'undefined') {
        store.commit('setPageTitle', to.meta.title ? i18n.t(to.meta.title) : '');
    }
});

initProgress(router);

export default router;
